import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-passwordchangedialog',
  templateUrl: './passwordchangedialog.component.html',
  styleUrls: ['./passwordchangedialog.component.css'],
})
export class PasswordchangedialogComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}
  close() {
    this.dialog.closeAll();
  }
}
